import React from 'react';
import CaptableContext from '.';

function useCaptable() {
   const { update, triggerUpdate } = React.useContext(CaptableContext);
   return { update, triggerUpdate };
}

export default useCaptable;
